export const selectActiveModal = ({ modal }) => modal.activeModal;
export const selectModalData = ({ modal }) => modal.data || {};
